export const settings = state => {
  return state.settings
}

export const tip_show = state => {
  return state.tip_show
}

export const channel_list = state => {
  return state.channel_list
}

export const channel = state => {
  return state.channel
}

export const aid = state => {
  return state.aid
}

export const active_menu = state => {
  return state.active_menu
}

export const default_sml = state => {
  return state.default_sml
}

export const holidayNow = state => {
  if(state.holiday.title){
    return true
  }else{
    return false
  }
}
